// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: /opt/dev_environment/assets/workspace/app-init/src/pages/StatistikPage/StatistikPage.css */

.statistik-page {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  padding-bottom: var(--space-2xl);
  min-height: 60vh;
}

/* ---- Header ---- */
.statistik-page__header {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}

.statistik-page__title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.statistik-page__title-icon {
  font-size: var(--font-size-xl);
}

.statistik-page__subtitle {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

/* ---- Headline Metrics Grid ---- */
.statistik-metrics {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-sm);
}

.statistik-metric-card {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  padding: var(--space-md);
  box-shadow: var(--shadow-sm);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-xs);
  text-align: center;
  border: 1.5px solid var(--color-border);
  transition: box-shadow var(--transition-fast);
}

.statistik-metric-card--highlight {
  border-color: var(--color-success);
  background-color: rgba(76, 175, 80, 0.04);
}

.statistik-metric-card--accent {
  border-color: var(--color-accent);
  background-color: rgba(255, 143, 0, 0.04);
}

.statistik-metric-card__icon {
  font-size: var(--font-size-xl);
  line-height: 1;
}

.statistik-metric-card__value {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-extrabold);
  color: var(--color-text-primary);
  line-height: var(--line-height-tight);
}

.statistik-metric-card__label {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

/* ---- Overall Progress Section ---- */
.statistik-progress-section {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  padding: var(--space-lg);
  box-shadow: var(--shadow-md);
}

.statistik-section-title {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin-bottom: var(--space-md);
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.statistik-section-title__icon {
  font-size: var(--font-size-lg);
}

.statistik-progress-ring {
  display: flex;
  align-items: center;
  gap: var(--space-lg);
}

.statistik-progress-ring__svg-container {
  position: relative;
  width: 100px;
  height: 100px;
  flex-shrink: 0;
}

.statistik-progress-ring__svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.statistik-progress-ring__track {
  fill: none;
  stroke: var(--color-progress-bg);
  stroke-width: 8;
}

.statistik-progress-ring__fill {
  fill: none;
  stroke: var(--color-success);
  stroke-width: 8;
  stroke-linecap: round;
  transition: stroke-dashoffset var(--transition-slow);
}

.statistik-progress-ring__percentage {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-extrabold);
  color: var(--color-text-primary);
}

.statistik-progress-ring__details {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}

.statistik-progress-ring__detail {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  display: flex;
  align-items: center;
  gap: var(--space-xs);
}

.statistik-progress-ring__detail-dot {
  width: 10px;
  height: 10px;
  border-radius: var(--radius-full);
  flex-shrink: 0;
}

.statistik-progress-ring__detail-dot--learned {
  background-color: var(--color-success);
}

.statistik-progress-ring__detail-dot--active {
  background-color: var(--color-accent);
}

.statistik-progress-ring__detail-value {
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

/* ---- Compartment Distribution Section ---- */
.statistik-distribution-section {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  padding: var(--space-lg);
  box-shadow: var(--shadow-md);
}

.statistik-distribution-bars {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}

.statistik-distribution-bar {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.statistik-distribution-bar__label {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-secondary);
  min-width: 48px;
  text-align: right;
  white-space: nowrap;
}

.statistik-distribution-bar__track {
  flex: 1 1;
  height: 24px;
  background-color: var(--color-progress-bg);
  border-radius: var(--radius-full);
  overflow: hidden;
  position: relative;
}

.statistik-distribution-bar__fill {
  height: 100%;
  border-radius: var(--radius-full);
  transition: width var(--transition-slow);
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: var(--space-sm);
}

.statistik-distribution-bar__fill--1 { background-color: var(--color-fach-1); }
.statistik-distribution-bar__fill--2 { background-color: var(--color-fach-2); }
.statistik-distribution-bar__fill--3 { background-color: var(--color-fach-3); }
.statistik-distribution-bar__fill--4 { background-color: var(--color-fach-4); }
.statistik-distribution-bar__fill--5 { background-color: var(--color-fach-5); }

.statistik-distribution-bar__count {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  min-width: 28px;
  text-align: left;
}

.statistik-distribution-bar__count--inside {
  color: white;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* ---- Error Rate Section ---- */
.statistik-errors-section {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  padding: var(--space-lg);
  box-shadow: var(--shadow-md);
}

.statistik-errors-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-md);
}

.statistik-errors-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;
}

.statistik-errors-table thead {
  background: linear-gradient(180deg, #f5efe6 0%, #ede4d6 100%);
}

.statistik-errors-table th {
  padding: var(--space-sm) var(--space-sm);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  color: var(--color-wood-dark);
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  border-bottom: 2px solid var(--color-border);
  white-space: nowrap;
}

.statistik-errors-table td {
  padding: var(--space-sm) var(--space-sm);
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
  border-bottom: 1px solid var(--color-border);
  vertical-align: middle;
  word-break: break-word;
}

.statistik-errors-table tbody tr:last-child td {
  border-bottom: none;
}

.statistik-errors-table tbody tr:nth-child(even) {
  background-color: rgba(245, 239, 230, 0.4);
}

.statistik-error-rate {
  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);
  font-weight: var(--font-weight-bold);
}

.statistik-error-rate--high {
  color: var(--color-error);
}

.statistik-error-rate--medium {
  color: var(--color-accent);
}

.statistik-error-rate--low {
  color: var(--color-success);
}

.statistik-error-rate__bar {
  width: 40px;
  height: 6px;
  background-color: var(--color-progress-bg);
  border-radius: var(--radius-full);
  overflow: hidden;
}

.statistik-error-rate__bar-fill {
  height: 100%;
  border-radius: var(--radius-full);
  transition: width var(--transition-normal);
}

.statistik-error-rate__bar-fill--high {
  background-color: var(--color-error);
}

.statistik-error-rate__bar-fill--medium {
  background-color: var(--color-accent);
}

.statistik-error-rate__bar-fill--low {
  background-color: var(--color-success);
}

.statistik-attempts {
  font-size: var(--font-size-xs);
  color: var(--color-text-light);
  white-space: nowrap;
}

.statistik-attempts__correct {
  color: var(--color-success);
  font-weight: var(--font-weight-semibold);
}

.statistik-attempts__incorrect {
  color: var(--color-error);
  font-weight: var(--font-weight-semibold);
}

/* ---- Expand Button ---- */
.statistik-expand-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-xs);
  width: 100%;
  padding: var(--space-sm) var(--space-md);
  margin-top: var(--space-sm);
  border-radius: var(--radius-md);
  border: 1.5px solid var(--color-border);
  background-color: var(--color-card-white);
  color: var(--color-text-secondary);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
}

.statistik-expand-btn:active {
  background-color: var(--color-progress-bg);
}

.statistik-expand-btn__icon {
  font-size: var(--font-size-sm);
  transition: transform var(--transition-fast);
}

.statistik-expand-btn--expanded .statistik-expand-btn__icon {
  transform: rotate(180deg);
}

/* ---- Empty State ---- */
.statistik-page__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 30vh;
  gap: var(--space-md);
  text-align: center;
  color: var(--color-text-secondary);
}

.statistik-page__empty-icon {
  font-size: 3rem;
}

.statistik-page__empty-title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.statistik-page__empty-text {
  font-size: var(--font-size-sm);
  max-width: 300px;
  line-height: var(--line-height-normal);
}

/* ---- Partial Empty State (for error section) ---- */
.statistik-errors-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-xl) var(--space-md);
  gap: var(--space-sm);
  text-align: center;
  color: var(--color-text-secondary);
}

.statistik-errors-empty__icon {
  font-size: 2rem;
}

.statistik-errors-empty__text {
  font-size: var(--font-size-sm);
  line-height: var(--line-height-normal);
  max-width: 280px;
}

/* ---- Danger Zone ---- */
.statistik-danger-zone {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  padding: var(--space-lg);
  box-shadow: var(--shadow-md);
  border: 1.5px solid rgba(229, 57, 53, 0.3);
}

.statistik-danger-zone__title {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  color: var(--color-error);
  margin-bottom: var(--space-xs);
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.statistik-danger-zone__title-icon {
  font-size: var(--font-size-lg);
}

.statistik-danger-zone__description {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  line-height: var(--line-height-normal);
  margin-bottom: var(--space-md);
}

.statistik-danger-zone__btn {
  width: 100%;
  padding: var(--space-md);
  border-radius: var(--radius-md);
  border: 2px solid var(--color-error);
  background-color: transparent;
  color: var(--color-error);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
}

.statistik-danger-zone__btn:hover {
  background-color: var(--color-error);
  color: white;
}

.statistik-danger-zone__btn:active {
  background-color: #c62828;
  color: white;
  transform: scale(0.98);
}

.statistik-danger-zone__btn-icon {
  font-size: var(--font-size-lg);
  line-height: 1;
}

/* ---- Reset Confirmation Dialog ---- */
.statistik-reset-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-md);
  animation: overlay-fade-in 0.2s ease-out;
}

.statistik-reset-dialog {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: 360px;
  padding: var(--space-lg);
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  text-align: center;
  animation: dialog-slide-up 0.25s ease-out;
}

.statistik-reset-dialog__icon {
  font-size: 3rem;
  line-height: 1;
}

.statistik-reset-dialog__title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-error);
}

.statistik-reset-dialog__message {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  line-height: var(--line-height-normal);
}

.statistik-reset-dialog__actions {
  display: flex;
  gap: var(--space-sm);
  padding-top: var(--space-xs);
}

.statistik-reset-dialog__btn {
  flex: 1 1;
  padding: var(--space-md) var(--space-md);
  border-radius: var(--radius-md);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  border: none;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
}

.statistik-reset-dialog__btn--cancel {
  background-color: var(--color-progress-bg);
  color: var(--color-text-secondary);
}

.statistik-reset-dialog__btn--cancel:active {
  background-color: var(--color-border);
}

.statistik-reset-dialog__btn--confirm {
  background-color: var(--color-error);
  color: white;
  box-shadow: var(--shadow-sm);
}

.statistik-reset-dialog__btn--confirm:active {
  background-color: #c62828;
}`, "",{"version":3,"sources":["webpack://./src/pages/StatistikPage/StatistikPage.css"],"names":[],"mappings":"AAAA,mGAAmG;;AAEnG;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,wBAAwB;EACxB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,uCAAuC;AACvC;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;EAChC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,+CAA+C;AAC/C;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,0CAA0C;EAC1C,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,wCAAwC;EACxC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,uCAAuC,qCAAqC,EAAE;AAC9E,uCAAuC,qCAAqC,EAAE;AAC9E,uCAAuC,qCAAqC,EAAE;AAC9E,uCAAuC,qCAAqC,EAAE;AAC9E,uCAAuC,qCAAqC,EAAE;;AAE9E;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA,iCAAiC;AACjC;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,gCAAgC;EAChC,4CAA4C;EAC5C,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;EACX,wCAAwC;EACxC,2BAA2B;EAC3B,+BAA+B;EAC/B,uCAAuC;EACvC,yCAAyC;EACzC,kCAAkC;EAClC,8BAA8B;EAC9B,wCAAwC;EACxC,eAAe;EACf,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,wBAAwB;EACxB,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,+BAA+B;EAC/B,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;EACzB,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,wCAAwC;EACxC,+BAA+B;EAC/B,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,YAAY;EACZ,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* File: /opt/dev_environment/assets/workspace/app-init/src/pages/StatistikPage/StatistikPage.css */\n\n.statistik-page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n  padding-bottom: var(--space-2xl);\n  min-height: 60vh;\n}\n\n/* ---- Header ---- */\n.statistik-page__header {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xs);\n}\n\n.statistik-page__title {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.statistik-page__title-icon {\n  font-size: var(--font-size-xl);\n}\n\n.statistik-page__subtitle {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n}\n\n/* ---- Headline Metrics Grid ---- */\n.statistik-metrics {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--space-sm);\n}\n\n.statistik-metric-card {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  padding: var(--space-md);\n  box-shadow: var(--shadow-sm);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-xs);\n  text-align: center;\n  border: 1.5px solid var(--color-border);\n  transition: box-shadow var(--transition-fast);\n}\n\n.statistik-metric-card--highlight {\n  border-color: var(--color-success);\n  background-color: rgba(76, 175, 80, 0.04);\n}\n\n.statistik-metric-card--accent {\n  border-color: var(--color-accent);\n  background-color: rgba(255, 143, 0, 0.04);\n}\n\n.statistik-metric-card__icon {\n  font-size: var(--font-size-xl);\n  line-height: 1;\n}\n\n.statistik-metric-card__value {\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-extrabold);\n  color: var(--color-text-primary);\n  line-height: var(--line-height-tight);\n}\n\n.statistik-metric-card__label {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n/* ---- Overall Progress Section ---- */\n.statistik-progress-section {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  padding: var(--space-lg);\n  box-shadow: var(--shadow-md);\n}\n\n.statistik-section-title {\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n  margin-bottom: var(--space-md);\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.statistik-section-title__icon {\n  font-size: var(--font-size-lg);\n}\n\n.statistik-progress-ring {\n  display: flex;\n  align-items: center;\n  gap: var(--space-lg);\n}\n\n.statistik-progress-ring__svg-container {\n  position: relative;\n  width: 100px;\n  height: 100px;\n  flex-shrink: 0;\n}\n\n.statistik-progress-ring__svg {\n  width: 100%;\n  height: 100%;\n  transform: rotate(-90deg);\n}\n\n.statistik-progress-ring__track {\n  fill: none;\n  stroke: var(--color-progress-bg);\n  stroke-width: 8;\n}\n\n.statistik-progress-ring__fill {\n  fill: none;\n  stroke: var(--color-success);\n  stroke-width: 8;\n  stroke-linecap: round;\n  transition: stroke-dashoffset var(--transition-slow);\n}\n\n.statistik-progress-ring__percentage {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-extrabold);\n  color: var(--color-text-primary);\n}\n\n.statistik-progress-ring__details {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xs);\n}\n\n.statistik-progress-ring__detail {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  display: flex;\n  align-items: center;\n  gap: var(--space-xs);\n}\n\n.statistik-progress-ring__detail-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: var(--radius-full);\n  flex-shrink: 0;\n}\n\n.statistik-progress-ring__detail-dot--learned {\n  background-color: var(--color-success);\n}\n\n.statistik-progress-ring__detail-dot--active {\n  background-color: var(--color-accent);\n}\n\n.statistik-progress-ring__detail-value {\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n}\n\n/* ---- Compartment Distribution Section ---- */\n.statistik-distribution-section {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  padding: var(--space-lg);\n  box-shadow: var(--shadow-md);\n}\n\n.statistik-distribution-bars {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n}\n\n.statistik-distribution-bar {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.statistik-distribution-bar__label {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-secondary);\n  min-width: 48px;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.statistik-distribution-bar__track {\n  flex: 1;\n  height: 24px;\n  background-color: var(--color-progress-bg);\n  border-radius: var(--radius-full);\n  overflow: hidden;\n  position: relative;\n}\n\n.statistik-distribution-bar__fill {\n  height: 100%;\n  border-radius: var(--radius-full);\n  transition: width var(--transition-slow);\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding-right: var(--space-sm);\n}\n\n.statistik-distribution-bar__fill--1 { background-color: var(--color-fach-1); }\n.statistik-distribution-bar__fill--2 { background-color: var(--color-fach-2); }\n.statistik-distribution-bar__fill--3 { background-color: var(--color-fach-3); }\n.statistik-distribution-bar__fill--4 { background-color: var(--color-fach-4); }\n.statistik-distribution-bar__fill--5 { background-color: var(--color-fach-5); }\n\n.statistik-distribution-bar__count {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n  min-width: 28px;\n  text-align: left;\n}\n\n.statistik-distribution-bar__count--inside {\n  color: white;\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-bold);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n/* ---- Error Rate Section ---- */\n.statistik-errors-section {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  padding: var(--space-lg);\n  box-shadow: var(--shadow-md);\n}\n\n.statistik-errors-section__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--space-md);\n}\n\n.statistik-errors-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  overflow: hidden;\n}\n\n.statistik-errors-table thead {\n  background: linear-gradient(180deg, #f5efe6 0%, #ede4d6 100%);\n}\n\n.statistik-errors-table th {\n  padding: var(--space-sm) var(--space-sm);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-wood-dark);\n  text-align: left;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  border-bottom: 2px solid var(--color-border);\n  white-space: nowrap;\n}\n\n.statistik-errors-table td {\n  padding: var(--space-sm) var(--space-sm);\n  font-size: var(--font-size-sm);\n  color: var(--color-text-primary);\n  border-bottom: 1px solid var(--color-border);\n  vertical-align: middle;\n  word-break: break-word;\n}\n\n.statistik-errors-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.statistik-errors-table tbody tr:nth-child(even) {\n  background-color: rgba(245, 239, 230, 0.4);\n}\n\n.statistik-error-rate {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-xs);\n  font-weight: var(--font-weight-bold);\n}\n\n.statistik-error-rate--high {\n  color: var(--color-error);\n}\n\n.statistik-error-rate--medium {\n  color: var(--color-accent);\n}\n\n.statistik-error-rate--low {\n  color: var(--color-success);\n}\n\n.statistik-error-rate__bar {\n  width: 40px;\n  height: 6px;\n  background-color: var(--color-progress-bg);\n  border-radius: var(--radius-full);\n  overflow: hidden;\n}\n\n.statistik-error-rate__bar-fill {\n  height: 100%;\n  border-radius: var(--radius-full);\n  transition: width var(--transition-normal);\n}\n\n.statistik-error-rate__bar-fill--high {\n  background-color: var(--color-error);\n}\n\n.statistik-error-rate__bar-fill--medium {\n  background-color: var(--color-accent);\n}\n\n.statistik-error-rate__bar-fill--low {\n  background-color: var(--color-success);\n}\n\n.statistik-attempts {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-light);\n  white-space: nowrap;\n}\n\n.statistik-attempts__correct {\n  color: var(--color-success);\n  font-weight: var(--font-weight-semibold);\n}\n\n.statistik-attempts__incorrect {\n  color: var(--color-error);\n  font-weight: var(--font-weight-semibold);\n}\n\n/* ---- Expand Button ---- */\n.statistik-expand-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-xs);\n  width: 100%;\n  padding: var(--space-sm) var(--space-md);\n  margin-top: var(--space-sm);\n  border-radius: var(--radius-md);\n  border: 1.5px solid var(--color-border);\n  background-color: var(--color-card-white);\n  color: var(--color-text-secondary);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.statistik-expand-btn:active {\n  background-color: var(--color-progress-bg);\n}\n\n.statistik-expand-btn__icon {\n  font-size: var(--font-size-sm);\n  transition: transform var(--transition-fast);\n}\n\n.statistik-expand-btn--expanded .statistik-expand-btn__icon {\n  transform: rotate(180deg);\n}\n\n/* ---- Empty State ---- */\n.statistik-page__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 30vh;\n  gap: var(--space-md);\n  text-align: center;\n  color: var(--color-text-secondary);\n}\n\n.statistik-page__empty-icon {\n  font-size: 3rem;\n}\n\n.statistik-page__empty-title {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n}\n\n.statistik-page__empty-text {\n  font-size: var(--font-size-sm);\n  max-width: 300px;\n  line-height: var(--line-height-normal);\n}\n\n/* ---- Partial Empty State (for error section) ---- */\n.statistik-errors-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-xl) var(--space-md);\n  gap: var(--space-sm);\n  text-align: center;\n  color: var(--color-text-secondary);\n}\n\n.statistik-errors-empty__icon {\n  font-size: 2rem;\n}\n\n.statistik-errors-empty__text {\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-normal);\n  max-width: 280px;\n}\n\n/* ---- Danger Zone ---- */\n.statistik-danger-zone {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  padding: var(--space-lg);\n  box-shadow: var(--shadow-md);\n  border: 1.5px solid rgba(229, 57, 53, 0.3);\n}\n\n.statistik-danger-zone__title {\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-error);\n  margin-bottom: var(--space-xs);\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.statistik-danger-zone__title-icon {\n  font-size: var(--font-size-lg);\n}\n\n.statistik-danger-zone__description {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  line-height: var(--line-height-normal);\n  margin-bottom: var(--space-md);\n}\n\n.statistik-danger-zone__btn {\n  width: 100%;\n  padding: var(--space-md);\n  border-radius: var(--radius-md);\n  border: 2px solid var(--color-error);\n  background-color: transparent;\n  color: var(--color-error);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-bold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-sm);\n}\n\n.statistik-danger-zone__btn:hover {\n  background-color: var(--color-error);\n  color: white;\n}\n\n.statistik-danger-zone__btn:active {\n  background-color: #c62828;\n  color: white;\n  transform: scale(0.98);\n}\n\n.statistik-danger-zone__btn-icon {\n  font-size: var(--font-size-lg);\n  line-height: 1;\n}\n\n/* ---- Reset Confirmation Dialog ---- */\n.statistik-reset-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 200;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-md);\n  animation: overlay-fade-in 0.2s ease-out;\n}\n\n.statistik-reset-dialog {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  width: 100%;\n  max-width: 360px;\n  padding: var(--space-lg);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n  text-align: center;\n  animation: dialog-slide-up 0.25s ease-out;\n}\n\n.statistik-reset-dialog__icon {\n  font-size: 3rem;\n  line-height: 1;\n}\n\n.statistik-reset-dialog__title {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-error);\n}\n\n.statistik-reset-dialog__message {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  line-height: var(--line-height-normal);\n}\n\n.statistik-reset-dialog__actions {\n  display: flex;\n  gap: var(--space-sm);\n  padding-top: var(--space-xs);\n}\n\n.statistik-reset-dialog__btn {\n  flex: 1;\n  padding: var(--space-md) var(--space-md);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-bold);\n  cursor: pointer;\n  border: none;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.statistik-reset-dialog__btn--cancel {\n  background-color: var(--color-progress-bg);\n  color: var(--color-text-secondary);\n}\n\n.statistik-reset-dialog__btn--cancel:active {\n  background-color: var(--color-border);\n}\n\n.statistik-reset-dialog__btn--confirm {\n  background-color: var(--color-error);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.statistik-reset-dialog__btn--confirm:active {\n  background-color: #c62828;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
